import LocationInterface from './LocationInterface';
export default LocationInterface;
